export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'destructive';
export type ButtonSize = 'sm' | 'md' | 'lg' | 'icon';

export const buttonBaseClass = [
    'inline-flex items-center justify-center gap-2 font-semibold transition-colors duration-150 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
    // Anneau plein décollé du bouton : ≥ 3:1 contre le fond (WCAG 1.4.11).
    'focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-surface',
].join(' ');

const variantClass: Record<ButtonVariant, string> = {
    primary:
        'bg-terracotta text-on-terracotta hover:bg-terracotta-hover active:bg-terracotta-active focus-visible:ring-terracotta',
    secondary:
        'border border-border bg-surface text-ink hover:bg-surface-2 active:bg-surface focus-visible:ring-terracotta',
    ghost: 'text-terracotta hover:bg-terracotta-soft active:bg-terracotta-soft/80 focus-visible:ring-terracotta',
    destructive:
        'bg-negative text-on-negative hover:bg-negative/90 active:bg-negative focus-visible:ring-negative',
};

const sizeClass: Record<ButtonSize, string> = {
    sm: 'text-xs px-3.5 py-2 rounded-[9px]',
    md: 'text-[13px] px-4.5 py-2.5 rounded-[10px]',
    lg: 'text-[15px] px-6 py-3.25 rounded-[11px]',
    icon: 'w-10 h-10 rounded-[10px] p-0 text-base',
};

export function buttonVariantClass(variant: ButtonVariant): string {
    return variantClass[variant] ?? '';
}

export function buttonSizeClass(size: ButtonSize): string {
    return sizeClass[size] ?? sizeClass.md;
}

/**
 * Classes de `Ui/Button`, pour un élément qui doit en avoir l'apparence sans
 * en être un : un lien de navigation (`Link`) présenté comme un bouton.
 */
export function buttonClass(
    variant: ButtonVariant = 'primary',
    size: ButtonSize = 'md',
): string {
    return [
        buttonBaseClass,
        buttonVariantClass(variant),
        buttonSizeClass(size),
    ].join(' ');
}
